module.exports = __webpack_public_path__ + "media/you-are-the-one.01900686.mp3";